import React, { useState } from "react";
import { MediumHeadingStyled } from "src/components/custom/texts/texts.styled";
import { Icon } from "@nubeteck/components";
import { Modal, Popover } from "antd";
import { useMediaQuery } from "src/hooks";
import { BoxStyled } from "./notifications.styled";
import { MenuButton } from "src/components/layout/mobile-menu/mobile-menu.style";

const Notifications = () => {
  const isMobile = useMediaQuery("(max-width: 1024px)");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal: () => void = () => {
    setIsModalOpen(true);
  };
  const handleOk: () => void = () => {
    setIsModalOpen(false);
  };

  const content = (
    <BoxStyled>
      <ul>
        <li>
          <p>
            <MediumHeadingStyled>Sin notificaciones</MediumHeadingStyled>
            {/* Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil commodi ut placeat animi
            praesentium sapiente quibusdam */}
          </p>
        </li>
      </ul>
    </BoxStyled>
  );

  return (
    <>
      {!isMobile ? (
        <Popover content={content} trigger="click" title={isMobile ? "" : "Notificaciones"}>
          <Icon isTouchable={true} name="notifications" color="white" />
        </Popover>
      ) : (
        <>
          <MenuButton type="text" withIcon icon={<Icon name="" />} onClick={showModal}>
            Notificaciones
          </MenuButton>
          <Modal
            title="Notificaciones"
            open={isModalOpen}
            onOk={handleOk}
            okText="Cerrar"
            cancelButtonProps={{ style: { display: "none" } }}
            width={800}
            onCancel={handleOk}
          >
            {content}
          </Modal>
        </>
      )}
    </>
  );
};

export default Notifications;
